<template>
  <router-view v-if="authStore.isInitialized"/>
  <div v-else>Loading...</div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const authStore = useAuthStore();
const router = useRouter();

onMounted(async () => {
  if (!authStore.isInitialized) {
    await authStore.initializeAuth();
  }
  
  if (!authStore.isAuthenticated && router.currentRoute.value.meta.requiresAuth) {
    router.push('/login');
  }
});
</script>